// extracted by mini-css-extract-plugin
export default {"row":"informationBoxes_row__mtcOf","item":"informationBoxes_item__DZK51"};